import type { Feature } from '@luna/gatekeeper';

export const cardLockAndReplace: Feature = {
    enabled: true,
    _description: 'Enables display of the refactored card lock and replace focus page',
};
